import { Component, OnInit, ViewEncapsulation, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NgForm } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';

declare var $: any;

@Component({
  selector: 'app-pickleball',
  templateUrl: './pickleball.component.html',
  styleUrls: ['./pickleball.component.css']
})
export class PickleballComponent implements OnInit {

  name: string = "";
  email: string = "";
  mobile: string = "";
  age: string = "";
  healthCover: string = "";
  goal: string = "";
  meeting_mode: string = "";
  nameValidateMessage: any = '';
  emailValidateMessage: string = '';
  mobileValidateMessage: string = '';
  ageValidateMessage: string = '';
  healthValidateMessage: string = '';
  modeValidateMessage: string = '';
  goalValidateMessage: string = '';

  intervalId: any;
  timeleft: number = 0;
  redirectToPage: string = "";
  clickedResend: number = 0;
  resendBtnTimer = 3;
  isLeadFormVisible: boolean = true;
  isOtpFormVisible: boolean = false;
  isThanksVisible: boolean = false;
  changeMobile: boolean = false;
  userOTP: string = "";
  isTimer: boolean = true;
  isResend: boolean = false;
  displayMobile: string = '';
  otpVerifiedStatus: boolean = true;

  visitorId: any;
  leadId: string = '';

  otpValidateMessage: string = '';

  meta_title: string = '';
  meta_desc: string = '';
  meta_keywords: string = '';
  meta_image: string = '';

  isResendOTP: boolean = false;
  otpVerify: string = '';

  visitortype: any;

  checkedTerms: string = 'true';


  hideSuggestion: boolean = false;
  pincode: string = "";
  pinValidateMessage: string = '';
  pincodeArr: any[] = [];
  city: string = "";
  pincodeDisplay: string = "";


  // Calendar and Time Slot Properties
  isCalendarPopupVisible: boolean = false;
  selectedDate: string = '';
  selectedTimeSlot: string = '';
  availableDates: any[] = [];
  timeSlots: string[] = [
    '10 AM - 11 AM',
    '11 AM - 12 PM',
    '12 PM - 01 PM',
    '01 PM - 02 PM',
    '02 PM - 03 PM',
    '03 PM - 04 PM',
    '04 PM - 05 PM',
    '05 PM - 06:PM'
  ];
  availableTimeSlots: string[] = [];
  popupmessage: string = '';
  isButtonDisabled: boolean = false;

  // Calendar Date Picker Properties
  currentMonth: moment.Moment = moment();
  calendarDays: any[] = [];
  selectedCalendarDate: moment.Moment | null = null;
  today: moment.Moment = moment();
  // appointmentTimestamp: string = '';
  appointmentDate: string = '';
  appointmentTime: string = '';

  showGoals = false;
  selectedGoals: string[] = [];
  goalOptions = [
    { value: 'Complete financial plan', label: 'Complete financial plan' },
    { value: 'Investment portfolio review', label: 'Investment portfolio review' },
    { value: 'Health insurance review', label: 'Health insurance review' },
    { value: 'Life/protection review', label: 'Life / Protection review' },
    { value: 'Retirement planning', label: 'Retirement planning' },
    { value: 'Tax-efficient planning', label: 'Tax-efficient planning' },
    { value: 'Child education/home goal', label: 'Child education / Home goal' },
    { value: 'Not sure—guide me', label: 'Not sure — guide me' }
  ];



  constructor(@Inject(DOCUMENT) private document: Document, private route: ActivatedRoute, private service: DataService, private titleService: Title, private metaService: Meta, private renderer: Renderer2) { }

  ngOnInit(): void {
    if (sessionStorage.getItem('visitorId')) {
      this.visitorId = '';
      sessionStorage.setItem('visitorId', '');
    }
    if (sessionStorage.getItem('leadId')) {
      this.leadId = '';
      sessionStorage.removeItem('leadId')
    }
    this.createVisitor();
    this.metaForSEO('Financial_Planning_Pickleball');
    this.initializeCalendar();
  }




  metaForSEO(slugname: string): void {
    this.service.getDynamicMeta().subscribe(
      (data: any) => {
        const seoPages = data?.rows?.[0]?.seo_pages || [];

        seoPages.forEach((v: any) => {
          if (v.seo_slug === slugname || v.seo_slug === "/" + slugname) {
            this.meta_title = v.seo_title;
            this.meta_desc = v.seo_description;
            this.meta_keywords = v.seo_keywords;

            this.titleService.setTitle(this.meta_title);
            this.metaService.removeTag('name="keywords"');
            this.metaService.removeTag('name="description"');
            this.metaService.addTags([
              { name: 'keywords', content: this.meta_keywords },
              { name: 'description', content: this.meta_desc },
              { name: 'robots', content: 'index, follow' }
            ]);
          }
        });
      },
      (err) => {
        console.error('Error fetching SEO metadata:', err);
      }
    );
  }




  createVisitor() {
    let jscd = window['jscd'];
    if (!sessionStorage.getItem('visitorId')) {
      let obj = {
        "browsername": jscd?.browser,
        "browserversion": jscd?.browser + ' ' + jscd?.browserVersion,
        "operatingsystem": jscd?.os + " " + jscd?.osVersion,
        "device": jscd?.os,
        "sourceurl": window.location.href,
        "productid": '69',
        "visitortype": "Financial_Planning_Pickleball",
        "utmsource": this.GetParameterValues("utm_source"),
        "utmmedium": this.GetParameterValues("utm_medium"),
        "leadsource": this.GetParameterValues("lead_source"),
        "utmcampaign": this.GetParameterValues("utm_campaign"),
      };
      this.visitortype = "Financial_Planning_Pickleball"; // VISITOR TYPE
      this.service.createVisitor(obj).subscribe((data: any) => {
        this.visitorId = data["visitorId"];
        sessionStorage.setItem('visitorId', data["visitorId"])
      },
        err => {
          console.log(err);
          throw err;
        })
    } else {
      this.visitorId = sessionStorage.getItem('visitorId')
    }
  }

  MobileDisplayLabel(mobile: string) {
    this.displayMobile = `${mobile.substr(0, 2)}XXXXX${mobile.substr(7, 9)}`;
  }


  async PostData() {
    this.MobileDisplayLabel(this.mobile);
    let val = await this.checkValidationMsg();
    if (val) {
      this.isCalendarPopupVisible = true;
      // this.createLead();
    }
    // this.isLeadFormVisible = false;
    // this.isOtpFormVisible = true;
    // this.isThanksVisible = false;
    // this.isTimer = true;
    // this.startTimer();
  }

  confirmAppointment() {
    this.createLead();
  }


  createLead() {
    let leadid = sessionStorage.getItem('leadId');
    this.visitorId = sessionStorage.getItem('visitorId')
    let obj = {
      "visitorid": this.visitorId,
      "leadid": leadid ? leadid : 0,
      "name": this.name,
      "mobile": this.mobile,
      "email": this.email,
      "pincode": this.pincode,
      "city": this.city
    }
    this.service.createLead(obj).subscribe((data: any) => {
      sessionStorage.setItem('leadId', data['leadid'])
      this.leadId = data['leadid'];
      // console.log('leadid:', this.leadId);
      this.sendToLsq();
      if (!data['success']) {
      }
    }, err => {
      console.log(err);
    })
  }


  sendToLsq() {
    let utm_source = this.GetParameterValues("utm_source");
    let utm_medium = this.GetParameterValues("utm_medium");
    let lead_source = this.GetParameterValues("lead_source");
    let utm_campaign = this.GetParameterValues("utm_campaign");

    const startTimeStr = this.selectedTimeSlot.split(' - ')[0];

    const slotMoment = moment(`${this.selectedDate} ${startTimeStr}`, 'YYYY-MM-DD hh:mm A');
    const slotDatetime = slotMoment.format('YYYY-MM-DD HH:mm:ss');

    this.service.pushLeadToLSQ(
      {
        visitor_type: this.visitortype,
        Name: this.name,
        Mobile: this.mobile,
        Email: this.email,
        Pincode: this.pincode,
        City: this.city,
        Remarks: `Age Group: ${this.age}, Primary interest: ${this.goal}, Health Cover: ${this.healthCover}, Meeting Mode: ${this.meeting_mode}`,
        SlotDatetime: slotDatetime,
        Campaign_Name: 'Financial_Planning_Pickleball',
        Landing_Page_URL: window.location.href,
        LEADID: this.leadId,
        Product: "Financial Planning",
        Sub_LeadSource: utm_source ? utm_source : 'Qr',
        Utm_Source: utm_source ? utm_source : 'Websites',
        Utm_Medium: utm_medium ? utm_medium : '',
        Utm_Campaign: utm_campaign ? utm_campaign : 'Financial_Planning_Pickleball',
        LeadSource: 'Event',
        // Entity_Type: 'Digital_BCL',
      }
    ).subscribe((res: any) => {
      if (res["success"]) {
        let sfid = res['id'];
      }
    });
    this.isLeadFormVisible = false;
    this.isThanksVisible = true;
    this.leadId = '';
    this.name = '';
    this.email = '';
    this.mobile = '';
    this.goal = '';
  }


  // sendOtp() {
  //   this.service.sendOtp({ leadid: this.leadId, mobile: this.mobile }).subscribe(data => {
  //     console.log("Leadid",this.leadId);
  //   }, err => {
  //     console.log(err);
  //   })
  // }

  // SubmitOTP(otpForm: NgForm) { 
  //   this.userOTP = otpForm.value.otp;
  //   if(this.userOTP){
  //   this.VerifyOTP();   
  //   }
  //   else{
  //     this.otpValidateMessage = "required";
  //   }
  // }


  // VerifyOTP() {
  //   $("#otp_verify_btn").attr("disabled", "true");
  //   document.getElementById("main_loader")!.style.display = 'block';
  //   //this.isResend = false;
  //   this.service.verifyOtp({ leadid: this.leadId, otp: this.userOTP }).subscribe(data => {
  //     if (data["success"]) {       
  //       $("#otp_verify_btn").removeAttr("disabled");

  //       document.getElementById("main_loader")!.style.display = 'none';
  //       sessionStorage.removeItem('leadId')
  //       let verifystatus = true;
  //       sessionStorage.setItem('formSubmitted','true');
  //       this.redirectTo(verifystatus);

  //       let utm_source=this.GetParameterValues("utm_source");
  //       let utm_medium=this.GetParameterValues("utm_medium");
  //       let lead_source=this.GetParameterValues("lead_source");
  //       let utm_campaign=this.GetParameterValues("utm_campaign");


  //       this.service.pushLeadToLSQ(
  //         {
  //           visitor_type: this.visitortype,
  //           Name: this.name,
  //           Mobile: this.mobile,
  //           Email: this.email,
  //           Campaign_Name:'SapnoKiUdaan' ,
  //           Landing_Page_URL: window.location.href,
  //           LEADID: this.leadId,
  //           Product:"Financial Planning",
  //           Sub_LeadSource :utm_source ? utm_source : 'Website',
  //           Utm_Source: utm_source ? utm_source : 'Websites',
  //           Utm_Medium: utm_medium ? utm_medium : '',
  //           Utm_Campaign: utm_campaign ? utm_campaign : '',
  //           LeadSource: 'Digital Marketing',
  //           Entity_Type: 'Digital_BCL',
  //         }
  //       ).subscribe((res:any) => {
  //         if (res["success"]) {
  //           let sfid = res['id'];      
  //         }
  //       });
  //       this.leadId = '';

  //   } else {
  //     $("#otp_verify_btn").removeAttr("disabled");
  //     document.getElementById("main_loader")!.style.display = 'none'; 
  //     sessionStorage.setItem('formSubmitted','false');      
  //     this.otpVerifiedStatus = false; 
  //   }
  // }, err => {
  //     $("#otp_verify_btn").removeAttr("disabled");
  //     console.log(err);
  //   })
  // }

  // backbtn(){
  //   console.log('backbtn')
  //   this.isLeadFormVisible=true;
  //   this.isOtpFormVisible=false;
  // }

  // redirectTo(resp: any) {
  //   if (resp == true) { 
  //     this.isThanksVisible = true;     
  //     $("body").removeClass('overflow');
  //     this.isLeadFormVisible = false;
  //     this.isOtpFormVisible = false; 
  //    }
  //   else {
  //     this.otpVerifiedStatus = false;
  //   }

  // }



  // startTimer() {
  //   clearInterval(this.intervalId);
  //   this.otpVerifiedStatus = true;
  //   this.timeleft = 20;
  //   this.timeleft -= 1;
  //   this.intervalId = setInterval(() => {
  //     if (this.timeleft == 0 && this.isOtpFormVisible == true) {
  //       if (this.clickedResend === this.resendBtnTimer) {
  //         this.isResend = false;
  //       }
  //       if (this.clickedResend > 0 && this.clickedResend < this.resendBtnTimer) {
  //         this.isResend = true;
  //       }
  //       this.isTimer = false;
  //       clearInterval(this.intervalId);       
  //       if (this.clickedResend == 0) {          
  //         this.isResend = true;
  //       }
  //     }
  //     this.timeleft -= 1;
  //   }, 1000);
  // }


  // resendOTP() {
  //   $("#otp_verify_btn").removeAttr("disabled");    
  //   //this.leadForm.controls['otp'].reset();
  //   this.userOTP = "";
  //   this.clickedResend++;
  //   this.isResendOTP=true;
  //   this.sendOtp();
  //   //this.leadForm.setErrors(null);
  //   this.startTimer();
  //   this.isTimer = true;
  //   this.isResend= false;
  // }

  // changeNumber() {
  //   $("#otp_verify_btn").removeAttr("disabled");
  //   this.userOTP = "";
  //   this.clickedResend = 0;
  //   this.changeMobile = true;
  //   this.isResend = false;
  //   this.isTimer = false; // to hide timer  
  //   // this.leadForm.setErrors({ 'incorrect': true });
  //   this.isLeadFormVisible = true;
  //   this.isOtpFormVisible = false;
  //   this.mobile = "";
  // }

  removeErrorMsg(fieldname: string) {
    // if(fieldname == "otp"){
    //   this.otpValidateMessage = "";
    //   this.otpVerifiedStatus = true; // to remove Invalid OTP message
    // }
    if (fieldname == "name") {
      this.nameValidateMessage = "";
    }
    if (fieldname == "email") {
      this.emailValidateMessage = "";
    }
    if (fieldname == "mobile") {
      this.mobileValidateMessage = "";
    }
    if (fieldname == "goal") {
      this.goalValidateMessage = "";
    }
    if (fieldname == "age") {
      this.ageValidateMessage = "";
    }
    if (fieldname == "pincode") {
      this.pinValidateMessage = "";
    }
    if (fieldname == "meeting_mode") {
      this.modeValidateMessage = "";
    }

  }


  checkValidationMsg() {
    // console.log('Checking')
    let num: number = 0;

    if (this.name && this.name.length < 3) {
      this.nameValidateMessage = "lengthError";
      num += 1;
    }
    if (!this.name) {
      this.nameValidateMessage = "required";
      num += 1;
    }

    if (!this.age) {
      this.ageValidateMessage = "required";
      num += 1;
    }

    if (!this.meeting_mode) {
      this.modeValidateMessage = "required";
      num += 1;
    }

    if (this.email && this.validateEmailAddress(this.email) == 0) {
      this.emailValidateMessage = "invalid";
      num += 1;
    }
    if (!this.email) {
      this.emailValidateMessage = "required";
      num += 1;
    }
    if (this.isMobileWrong(this.mobile) == 0) {
      this.mobileValidateMessage = "invalid";
      num += 1;
    }
    if (!this.mobile) {
      this.mobileValidateMessage = "required";
      num += 1;
    }
    if (this.mobile && this.mobile.length != 10) {
      this.mobileValidateMessage = "lengthError";
      num += 1;
    }

    if (!this.pincode) {
      this.pinValidateMessage = "required";
      num += 1;
    }
    if (this.pincode && this.pincode.length != 6) {
      this.pinValidateMessage = "invalid";
      num += 1;
    }
    if (this.pincodeArr.length == 0) {
      this.pinValidateMessage = "invalid";
      num += 1;
    }

    if (this.selectedGoals.length === 0) {
      this.goalValidateMessage = "required";
      num++;
    }

    if (num > 0) {
      return false;
    } else {
      return true;
    }
  }

  toggleGoal(goal: string) {
    const index = this.selectedGoals.indexOf(goal);

    if (index > -1) {
      // Deselect
      this.selectedGoals.splice(index, 1);
    } else if (this.selectedGoals.length < 3) {
      // Select
      this.selectedGoals.push(goal);
    }

    // Update goal
    this.goal = this.selectedGoals.length
      ? this.selectedGoals.join(", ")
      : "";
  }

  openSuggestionBox(event: Event, flag: string) {
    const target = event.target as HTMLInputElement | null;
    if (target && target.value.length > 0) { // Ensure target is not null
      if (flag === 'form') {
        this.hideSuggestion = true;
      }
    }
  }
  hideSuggestionDiv(flag: string) {
    if (flag == 'form') {
      this.hideSuggestion = false;
      if (this.pincode) {
        this.pinValidateMessage = "";
      }
    }
  }
  getPincodeList(event: Event, flag: string) {
    const pincode = (event.target as HTMLInputElement).value; // Safely access the value of the input
    if (flag === 'form') {
      if (pincode.length <= 3) {
        this.hideSuggestion = false;
      }
      this.service.cityFiler(pincode).subscribe((response: any) => {
        if (pincode.length > 3) {
          this.hideSuggestion = true;
          this.pincodeArr = response['data']; // pincode | citycode | cityname
          if (this.pincodeArr.length === 0) {
            this.pinValidateMessage = "invalid";
          }
        }
      })
    }
    if (flag === 'form') {
      if (pincode.length <= 3) {
        this.hideSuggestion = false;
      }
      this.service.cityFiler(pincode).subscribe((response: any) => {
        if (pincode.length > 3) {
          this.hideSuggestion = true;
          this.pincodeArr = response['data']; // pincode | citycode | cityname
          if (this.pincodeArr.length === 0) {
            this.pinValidateMessage = "invalid";
          }
        }
      })
    }
  }

  setpincode(pinObj: any, flag: string) {
    if (flag == 'form') {
      this.city = pinObj.cityname;
      this.pincode = pinObj.pincode;
      this.pincodeDisplay = `${pinObj.pincode} - ${pinObj.cityname}`;
      this.hideSuggestion = false;
    }
  }



  otpValidate() {
    console.log('otpValidate')
    let num: number = 0;
    if (this.userOTP && this.userOTP.length != 6) {
      this.otpValidateMessage = "lengthError";
      num += 1;
    }
    if (num > 0) {
      return false;
    }
    return;
  }

  validateEmailAddress(email: string) {
    if (email) {
      var lastChars = email.lastIndexOf(".");
      var expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
      if (!expression.test(String(email).toLowerCase()) || email.substring(lastChars, 3).length < 3) {
        return 0;
      }
      else {
        return 1;
      }
    }
    return
  }

  isMobileWrong(mobile: string) {
    let firstDigit = mobile.substring(0, 1);
    if (firstDigit != '6' && firstDigit != '7' && firstDigit != '8' && firstDigit != '9') {
      return 0;
    }
    else if (mobile.match(/^(\d)\1+$/g)) {
      return 0;
    }
    else {
      return 1;
    }
  }


  alphaOnly(event: any) {
    var key = event.keyCode;
    return ((key >= 65 && key <= 90) || (key == 8 || key == 32));
  };

  numbersOnly($event: any) {
    if ($event.target.value.length === 0) {
      if ($event.key === '0' || $event.key === '1' || $event.key === '2' || $event.key === '3' || $event.key === '4' || $event.key === '5') {
        return false;
      }
    }
    var reg = /^[0-9]+$/;
    return (reg.test($event.key));
  };

  numberspincode($event: any) {
    if ($event.target.value.length === 0) {
      if ($event.key === '0') {
        return false;
      }
    }
    var reg = /^[0-9]+$/;
    return (reg.test($event.key));
  };

  numbersOnlyotp($event: any) {
    return /^[0-9]$/.test($event.key);
  };

  GetParameterValues(param: string) {
    var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < url.length; i++) {
      var urlparam = url[i].split('=');
      if (urlparam[0] == param) {
        return urlparam[1];
      }
    }
    return
  }

  scroll() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.getElementById('fill-form')!.style.display = 'block';
  }

  desktopscroll() {
    document.getElementById('fill-form')!.style.display = 'block';
  }


  // Calendar and Time Slot Methods
  initializeCalendar() {
    // Debug: Show what dates are available
    const availableDates = this.getNextAvailableDates();
    // console.log('Next 3 available dates:', availableDates.map(date => ({
    //   date: date.format('YYYY-MM-DD'),
    //   day: date.format('dddd')
    // })));

    this.generateCalendarDays();
  }

  generateCalendarDays() {
    const startOfMonth = this.currentMonth.clone().startOf('month');
    const endOfMonth = this.currentMonth.clone().endOf('month');
    const startDate = startOfMonth.clone().startOf('week');
    const endDate = endOfMonth.clone().endOf('week');

    this.calendarDays = [];
    const current = startDate.clone();

    while (current.isSameOrBefore(endDate, 'day')) {
      const dayObj = {
        date: current.clone(),
        isCurrentMonth: current.isSame(this.currentMonth, 'month'),
        isToday: current.isSame(this.today, 'day'),
        isSelected: this.selectedCalendarDate ? current.isSame(this.selectedCalendarDate, 'day') : false,
        isDisabled: this.isDateDisabled(current),
        isAvailable: this.isDateAvailable(current)
      };

      // Debug logging for available dates
      if (dayObj.isAvailable && dayObj.isCurrentMonth) {
        // console.log('Available date:', current.format('YYYY-MM-DD'), {
        //   dayOfWeek: current.day(),
        //   dayName: current.format('dddd'),
        //   isAvailable: dayObj.isAvailable,
        //   isDisabled: dayObj.isDisabled
        // });
      }

      this.calendarDays.push(dayObj);
      current.add(1, 'day');
    }
  }

  isDateAvailable(date: moment.Moment): boolean {
    const today = moment().startOf('day');
    const lastAvailableDate = moment('2026-10-31', 'YYYY-MM-DD');

    // Allow only dates from today through 9 Aug
    return !date.isBefore(today, 'day') &&
      !date.isAfter(lastAvailableDate, 'day');
  }

  getNextAvailableDates(): moment.Moment[] {
    const today = moment().startOf('day');
    const lastAvailableDate = moment('2026-10-31', 'YYYY-MM-DD');

    const availableDates: moment.Moment[] = [];
    let currentDate = today.clone();

    while (currentDate.isSameOrBefore(lastAvailableDate, 'day')) {
      // For today, check if time slots are available
      if (currentDate.isSame(today, 'day')) {
        const todayTimeSlots = this.getAvailableTimeSlots(
          currentDate.format('YYYY-MM-DD')
        );

        if (todayTimeSlots.length > 0) {
          availableDates.push(currentDate.clone());
        }
      } else {
        availableDates.push(currentDate.clone());
      }

      currentDate.add(1, 'day');
    }

    return availableDates;
  }

  selectDate(selectedDateObj: any) {
    if (selectedDateObj.isAvailable && !selectedDateObj.isDisabled) {
      this.selectedCalendarDate = selectedDateObj.date;
      this.selectedDate = selectedDateObj.date.format('YYYY-MM-DD');
      this.selectedTimeSlot = ''; // Reset time slot when date changes
      this.generateCalendarDays(); // Refresh calendar to update selection
    }
  }

  selectCalendarDate(day: any) {
    if (day.isAvailable && !day.isDisabled) {
      this.currentMonth = day.date.clone().startOf('month');
      this.selectedCalendarDate = day.date;
      this.selectedDate = day.date.format('YYYY-MM-DD');
      this.selectedTimeSlot = '';
      this.availableTimeSlots = this.getAvailableTimeSlots(this.selectedDate);
      this.generateCalendarDays();
    }
  }

  previousMonth() {
    this.currentMonth.subtract(1, 'month');
    this.generateCalendarDays();
  }

  nextMonth() {
    this.currentMonth.add(1, 'month');
    this.generateCalendarDays();
  }

  goToToday() {
    this.currentMonth = moment();
    this.generateCalendarDays();
  }

  clearSelection() {
    this.selectedCalendarDate = null;
    this.selectedDate = '';
    this.selectedTimeSlot = '';
    this.generateCalendarDays();
  }

  selectTimeSlot(timeSlot: string) {
    this.selectedTimeSlot = timeSlot;
  }

  getAvailableTimeSlots(selectedDate: string): string[] {
    const today = moment();
    const selectedMoment = moment(selectedDate);

    // If selected date is today, filter time slots based on current time
    if (selectedMoment.isSame(today, 'day')) {
      const currentTime = moment();
      const currentHour = currentTime.hour();
      const currentMinute = currentTime.minute();

      return this.timeSlots.filter(timeSlot => {
        // Extract start time from time slot (e.g., "10:00 AM - 11:00 AM" -> "10:00 AM")
        const startTimeStr = timeSlot.split(' - ')[0];
        const startTime = moment(startTimeStr, 'hh:mm A');
        const slotHour = startTime.hour();
        const slotMinute = startTime.minute();

        // If current time is past this slot's start time, don't include it
        if (currentHour > slotHour || (currentHour === slotHour && currentMinute >= slotMinute)) {
          return false;
        }

        return true;
      });
    }

    // For future dates, return all time slots
    return this.timeSlots;
  }

  closeCalendarPopup() {
    this.isCalendarPopupVisible = false;
    $("body").removeClass('overflow');
  }


  isDateDisabled(date: moment.Moment): boolean {
    const today = moment().startOf('day');
    const lastAvailableDate = moment('2026-10-31', 'YYYY-MM-DD');

    return date.isBefore(today, 'day') ||
      date.isAfter(lastAvailableDate, 'day');
  }

  isAppointmentReady(): boolean {
    return !!(this.selectedDate && this.selectedTimeSlot);
  }

  onFocusOut(event: FocusEvent) {
    const nextFocusedElement = event.relatedTarget as HTMLElement;
    // Don't close if focus is still inside the dropdown
    if (nextFocusedElement && event.currentTarget instanceof HTMLElement) {
      if (event.currentTarget.contains(nextFocusedElement)) {
        return;
      }
    }
    this.showGoals = false;
  }

}
